export default __webpack_public_path__ + "static/media/sentry.360d4625.svg";